export default __webpack_public_path__ + "static/media/intro.62338e65.webp";